/* eslint-disable no-restricted-globals */
/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */

import { uri as assetsEngLogo } from '../assets/engetap';
import manufacturies from '../assets/manufacturies';
import { formatPressureValue, toBarNumber } from '../../utils/pressure';
import styles from './styles';

const { format } = require('date-fns');

const INITIAL_STATE = {
  currentPMTA: '',
  dateToExternalInsp: '',
  dateToInternalInsp: '',
  tag: '',
  tapNumber: '', //
  reportNumber: '', //
  createdAt: '', //
  art: '', //
  client: {
    companyName: '',
    address: '',
    city: '',
    uf: '',
  },
  equipment: {
    vasselPosition: '',
    fluid: '',
    location: '',
  },
  namePlate: {
    manufacture: '',
    yearOfManufacture: '',
    model: '',
    serialNumber: '',
    volume: '',
    category: '', // Salvar do resultado do laudo
    riskGroup: '', // Salvar do resultado do laudo
    vesselFunction: '',
    operatingPressure: { bar: '' },
    hidrostatico: { bar: '' },
  },

  accessoriesPhotos: {
    manometer: {
      brand: '',
      indRangeStart: {
        bar: '',
        current: {
          value: '',
          unity: '',
        },
      },
      indRangeEnd: {
        bar: '',
        current: {
          value: '',
          unity: '',
        },
      },
      cDiameter: '',
      seal: '',
    },

    safetyValve: {
      brand: '',
      cDiameter: '',
      seal: '',
    },

    reliefValve: {
      brand: '',
      cDiameter: '',
      seal: '',
    },

    dreno: {
      text: '',
    },
  },

  valve: {
    brand: '',
    cDiameter: '',
    opening: { bar: '' },
    settlement: { bar: '' },
    createdAt: '',
    certificateNumber: '',
    seal: '',
  },
  manometer: {
    brand: '',
    cDiameter: '',
    createdAt: '',
    certificateNumber: '',
    seal: '',
    class: '',
    indRangeStart: { bar: '' },
    indRangeEnd: { bar: '' },
  },
};

class InspectionPDF {
  constructor(inspection = INITIAL_STATE) {
    this.inspection = inspection.inspection;
    this.manometer = inspection.manometer || INITIAL_STATE.manometer;
    this.valve = inspection.valve || INITIAL_STATE.valve;
    this.client = inspection.client || INITIAL_STATE.client;

    // `valves` (todas as calibrações de válvula do contrato) passou a ser devolvido pela API;
    // `valve` (calibração única vinculada à inspeção) é o fallback para respostas antigas.
    this.valves = Array.isArray(inspection.valves) && inspection.valves.length
      ? inspection.valves.filter(Boolean)
      : [inspection.valve].filter((item) => item && item.brand);

    // Older inspections don't have manufacturerName/manufacturerRef (the API only
    // started resolving those recently), so the legacy id-based lookup is kept as a
    // fallback to avoid regressing their PDFs to "Desconhecido".
    this.manufacturerId = this.inspection?.namePlate?.manufacturer || 1;
    this.vesselManufacturerName = this.inspection?.namePlate?.manufacturerName
      || this.inspection?.namePlate?.manufacturerRef?.name
      || manufacturies.find((manufacturer) => manufacturer.id === this.manufacturerId)?.name
      || 'Desconhecido';

    this.accessoriesPhotos = this.normalizeAccessoryItems(
      (this.inspection && this.inspection.accessoriesPhotos) || {},
    );
  }

  /**
   * The mobile app now stores up to 3 items per accessory type as arrays
   * (manometers/safetyValves/reliefValves/drenos). Older inspections may still have
   * the single-object shape (manometer/safetyValve/reliefValve/dreno), so both are
   * accepted here and normalized to arrays.
   */
  normalizeAccessoryItems(accessoriesPhotos) {
    const source = accessoriesPhotos || {};
    const toItems = (pluralKey, singularKey) => {
      const pluralValue = source[pluralKey];
      if (Array.isArray(pluralValue)) {
        return pluralValue.filter(Boolean).slice(0, 3);
      }
      const singularValue = source[singularKey];
      return singularValue && typeof singularValue === 'object' ? [singularValue] : [];
    };

    return {
      manometers: toItems('manometers', 'manometer'),
      safetyValves: toItems('safetyValves', 'safetyValve'),
      reliefValves: toItems('reliefValves', 'reliefValve'),
      drenos: toItems('drenos', 'dreno'),
    };
  }

  /**
   * Escala do manômetro. Zeros à direita são descartados ("2.00" -> "2"), mas casas
   * decimais significativas são mantidas ("0.60" -> "0.6"), conforme pedido do cliente.
   */
  formatBarRange(start, end, multiplier = 1) {
    const startBar = toBarNumber(start);
    const endBar = toBarNumber(end);
    const decimals = multiplier === 1 ? 2 : 0;
    const formatted = (value) => {
      if (value === null) {
        return ' -';
      }
      const fixed = (value * multiplier).toFixed(decimals);
      return fixed.includes('.') ? fixed.replace(/\.?0+$/, '') : fixed;
    };
    return `${formatted(startBar)} - ${formatted(endBar)}`;
  }

  renderValveAccessoryTable(item, title) {
    return {
      margin: [0, 25, 0, 0],
      layout: {
        vLineColor: 'gray',
        hLineColor: 'gray',
      },
      table: {
        widths: ['33%', '32%', '35%'],
        body: [
          [
            {
              style: 'tableHeader',
              text: title,
              colSpan: 3,
              border: [false, false, false, true],
            },
            {},
            {},
          ],
          [
            {
              border: [false, false, false, false],
              style: 'tableContentFirst',
              text: [
                { text: 'FABRICANTE:', color: '#7e97ad' },
                { text: ` ${item.brand || ' -'}` },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, false],
              text: [
                { text: 'DIÂMETRO DA CONEXÃO:', color: '#7e97ad' },
                { text: ` ${item.cDiameter ? `${item.cDiameter}"` : ' -'}` },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, false],
              text: [
                { text: 'LACRE:', color: '#7e97ad' },
                { text: ` ${item.seal || ' -'}` },
              ],
            },
          ],
        ],
      },
    };
  }

  /** Tabela completa da válvula: dados do acessório + dados da calibração. */
  renderValveCalibrationTable(valve, title) {
    return {
      margin: [0, 25, 0, 0],
      layout: {
        vLineColor: 'gray',
        hLineColor: 'gray',
      },
      table: {
        widths: ['38%', '27%', '35%'],
        body: [
          // HEADER
          [
            {
              style: 'tableHeader',
              text: title,
              colSpan: 3,
              border: [false, false, false, true],
            },
            {},
            {},
          ],
          // CONTENT
          // FIRST
          [
            {
              border: [false, false, false, true],
              style: 'tableContentFirst',
              text: [
                { text: 'FABRICANTE:', color: '#7e97ad' },
                { text: ` ${valve.brand || ' -'}` },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, true],
              text: [
                { text: 'DIÂMETRO DA CONEXÃO:', color: '#7e97ad' },
                { text: ` ${valve.cDiameter ? `${valve.cDiameter}"` : ' -'}` },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, true],
              text: [
                { text: 'PRESSÃO DE ABERTURA:', color: '#7e97ad' },
                { text: ` ${formatPressureValue(valve.opening)}` },
              ],
            },
          ],
          // OTHERS
          [
            {
              style: 'tableContentOthers',
              border: [false, false, false, true],
              text: [
                { text: 'PRESSÃO DE ASSENTAMENTO:', color: '#7e97ad' },
                { text: ` ${formatPressureValue(valve.settlement)}` },
              ],
            },
            {
              style: 'tableContentOthers',
              border: [false, false, false, true],
              text: [
                { text: 'DATA DA CALIBRAÇÃO:', color: '#7e97ad' },
                {
                  text: ` ${
                    valve.createdAt
                      ? format(new Date(valve.createdAt), 'dd/MM/yyy')
                      : ' -'
                  }`,
                },
              ],
            },
            {
              style: 'tableContentOthers',
              border: [false, false, false, true],
              text: [
                { text: 'CERTIFICADO:', color: '#7e97ad' },
                { text: ` ${valve.certificateNumber || ' -'}` },
              ],
            },
          ],
          // END
          [
            {
              style: 'tableContentOthers',
              border: [false, false, false, false],
              text: [
                { text: 'LACRE:', color: '#7e97ad' },
                { text: ` ${valve.seal || ' -'}` },
              ],
            },
            {
              style: 'tableContentOthers',
              border: [false, false, false, false],
              colSpan: 2,
              text: [
                { text: 'CALIBRADO POR:', color: '#7e97ad' },
                { text: ' FERNANDO GUIMARÃES DE SOUSA' },
              ],
            },
            {},
          ],
        ],
      },
    };
  }

  /**
   * O app permite cadastrar mais de uma válvula, mas a inspeção só referencia uma calibração
   * (`valveId`). A API passa a devolver todas as calibrações do contrato cujo lacre aparece
   * nos acessórios (`valves`), então aqui montamos uma tabela por válvula cadastrada,
   * casando cada acessório com a sua calibração pelo lacre. Sem calibração, cai na tabela
   * simples do acessório; sem acessórios (registros antigos), usa a calibração isolada.
   */
  valveCalibrationFor(item) {
    const calibrations = this.valves;

    if (!calibrations.length) {
      return null;
    }

    const seal = `${(item && item.seal) || ''}`.trim();
    if (seal) {
      const bySeal = calibrations.find(
        (calibration) => `${calibration.seal || ''}`.trim() === seal,
      );
      if (bySeal) {
        return bySeal;
      }
    }

    // Uma única válvula cadastrada e uma única calibração: são a mesma válvula, mesmo que o
    // lacre tenha sido corrigido na web depois da inspeção.
    const accessoriesCount = this.accessoriesPhotos.safetyValves.length
      + this.accessoriesPhotos.reliefValves.length;
    if (accessoriesCount === 1 && calibrations.length === 1) {
      return calibrations[0];
    }

    return null;
  }

  /**
   * Dados da calibração têm prioridade, mas campos vazios nela (ex.: bitola não informada na
   * bancada) caem para o que foi cadastrado como acessório no app.
   */
  mergeValve(item, calibration) {
    const pick = (preferred, fallback) => (
      preferred !== undefined && preferred !== null && `${preferred}`.trim() !== ''
        ? preferred
        : fallback
    );

    return {
      ...item,
      ...calibration,
      brand: pick(calibration.brand, item.brand),
      cDiameter: pick(calibration.cDiameter, item.cDiameter),
      seal: pick(calibration.seal, item.seal),
    };
  }

  renderValveTables() {
    const accessories = [
      ...this.accessoriesPhotos.safetyValves.map((item) => ({
        item,
        label: 'DADOS DA VÁLVULA DE SEGURANÇA',
        total: this.accessoriesPhotos.safetyValves.length,
      })),
      ...this.accessoriesPhotos.reliefValves.map((item) => ({
        item,
        label: 'DADOS DA VÁLVULA DE ALÍVIO',
        total: this.accessoriesPhotos.reliefValves.length,
      })),
    ];

    if (!accessories.length) {
      // Nenhum acessório cadastrado: mantém o comportamento antigo com a calibração vinculada.
      const tables = this.valves
        .filter((calibration) => calibration && calibration.brand)
        .map((calibration, index) => this.renderValveCalibrationTable(
          calibration,
          this.valves.length > 1
            ? `DADOS DA VÁLVULA DE SEGURANÇA ${index + 1}`
            : 'DADOS DA VÁLVULA DE SEGURANÇA',
        ));

      return tables.length ? { stack: tables } : {};
    }

    let safetyIndex = 0;
    let reliefIndex = 0;

    const tables = accessories.map(({ item, label, total }) => {
      let title = label;
      if (total > 1) {
        if (label.includes('SEGURANÇA')) {
          safetyIndex += 1;
          title = `${label} ${safetyIndex}`;
        } else {
          reliefIndex += 1;
          title = `${label} ${reliefIndex}`;
        }
      }

      const calibration = this.valveCalibrationFor(item);

      return calibration
        ? this.renderValveCalibrationTable(this.mergeValve(item, calibration), title)
        : this.renderValveAccessoryTable(item, title);
    });

    return { stack: tables };
  }

  renderManometerAccessoryTable(item, title) {
    return {
      margin: [0, 25, 0, 0],
      layout: {
        vLineColor: 'gray',
        hLineColor: 'gray',
      },
      table: {
        widths: ['30%', '35%', '35%'],
        body: [
          [
            {
              style: 'tableHeader',
              text: title,
              colSpan: 3,
              border: [false, false, false, true],
            },
            {},
            {},
          ],
          [
            {
              border: [false, false, false, true],
              style: 'tableContentFirst',
              text: [
                { text: 'FABRICANTE:', color: '#7e97ad' },
                { text: ` ${item.brand || ' -'}` },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, true],
              text: [
                { text: 'ESCALA EM BAR:', color: '#7e97ad' },
                {
                  text: ` ${this.formatBarRange(item.indRangeStart, item.indRangeEnd)} [bar]`,
                },
              ],
            },
            {
              style: 'tableContentFirst',
              border: [false, false, false, true],
              text: [
                { text: 'ESCALA EM PSI:', color: '#7e97ad' },
                {
                  text: ` ${
                    this.formatBarRange(item.indRangeStart, item.indRangeEnd, 14.5038)
                  } [PSI]`,
                },
              ],
            },
          ],
          [
            {
              style: 'tableContentOthers',
              border: [false, false, false, false],
              text: [
                { text: 'DIÂMETRO DA CONEXÃO:', color: '#7e97ad' },
                { text: ` ${item.cDiameter ? `${item.cDiameter}"` : ' -'}` },
              ],
            },
            {
              style: 'tableContentOthers',
              border: [false, false, false, false],
              text: [
                { text: 'CLASSE:', color: '#7e97ad' },
                { text: ' -' },
              ],
            },
            {
              style: 'tableContentOthers',
              border: [false, false, false, false],
              text: [
                { text: 'LACRE:', color: '#7e97ad' },
                { text: ` ${item.seal || ' -'}` },
              ],
            },
          ],
        ],
      },
    };
  }

  renderManometerAccessoryTables() {
    const items = this.accessoriesPhotos.manometers;
    if (!items.length) {
      return {};
    }

    const tables = items.map((item, index) => this.renderManometerAccessoryTable(
      item,
      items.length > 1 ? `DADOS DO MANÔMETRO ${index + 1}` : 'DADOS DO MANÔMETRO',
    ));

    return { stack: tables };
  }

  cmToPoint(cm) {
    const pol = cm * 0.393701;
    return pol * 72;
  }

  header({ engetapLogo }) {
    return [
      {
        // [left,top,right,botton]
        margin: [0, this.cmToPoint(1), 0, 0],
        layout: {
          vLineColor: 'gray',
          hLineColor: 'gray',
        },
        table: {
          widths: ['50%', '50%'],
          body: [
            [
              {
                margin: [35, 10, 0, 0],
                border: [false, false, false, false],
                stack: [
                  {
                    alignment: 'left',
                    fontSize: 10,
                    text: [
                      {
                        text: 'CLIENTE: ',
                        bold: true,
                      },
                      {
                        text: ` ${
                          this.client && this.client.companyName ? this.client.companyName : ''
                        }`,
                      },
                    ],
                  },
                  {
                    alignment: 'left',
                    fontSize: 10,

                    text: [
                      {
                        text: 'ENDEREÇO: ',
                        bold: true,
                      },
                      {
                        text: ` ${this.client && this.client.address ? this.client.address : ''}`,
                      },
                    ],
                  },
                  {
                    alignment: 'left',
                    fontSize: 10,
                    text: [
                      {
                        text: 'CIDADE: ',
                        bold: true,
                      },
                      {
                        text: `${this.client && this.client.city ? this.client.city : ''}. `,
                      },
                      {
                        text: ' ESTADO: ',
                        bold: true,
                      },
                      {
                        text: ` ${this.client && this.client.uf ? this.client.uf : ''}`,
                      },
                    ],
                  },
                ],
              },
              {
                // [left,top,right,botton]
                margin: [0, 10, 25, 0],
                alignment: 'right',
                image: engetapLogo,
                height: 35,
                width: 145,
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
    ];
  }

  content() {
    return [
      // TITLE
      {
        margin: [0, 25, 0, 0],
        text: 'RELATÓRIO RESUMO DA INSPEÇÃO',
        alignment: 'center',
        fontSize: 24,
        color: '#7e97ad',
        lineHeight: 1.25,
        bold: true,
      },
      {
        text: `Nº TAP: ${
          this.inspection && this.inspection.tapNumber ? this.inspection.tapNumber : ' -'
        }`,
        alignment: 'center',
        fontSize: 24,
        color: '#7e97ad',
        lineHeight: 1.25,
        bold: true,
      },
      // FIRST TABLE
      {
        margin: [0, 10, 0, 0],
        layout: {
          vLineColor: 'gray',
          hLineColor: 'gray',
        },
        table: {
          widths: ['30%', '35%', '35%'],
          body: [
            // HEADER
            [
              {
                style: 'tableHeader',
                text: 'DADOS DO VASO',
                colSpan: 3,
                border: [false, false, false, true],
              },
              {},
              {},
            ],
            // CONTENT
            // FIRST
            [
              {
                border: [false, false, false, true],
                style: 'tableContentFirst',
                text: [
                  {
                    text: 'TAG:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.tag || ' 00'}`,
                  },
                ],
              },
              {
                style: 'tableContentFirst',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'FABRICANTE:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.vesselManufacturerName}`,
                  },
                ],
              },
              {
                style: 'tableContentFirst',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'ANO DE FABRICAÇÃO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.yearOfManufacture
                        ? this.inspection.namePlate.yearOfManufacture
                        : ' -'
                    }`,
                  },
                ],
              },
            ],
            // OTHERS
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'MODELO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.model
                        ? this.inspection.namePlate.model
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'Nº DE SÉRIE:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.serialNumber
                        ? this.inspection.namePlate.serialNumber
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'POSIÇÃO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.equipment
                      && this.inspection.equipment.vesselPosition
                        ? this.capitalize(this.inspection.equipment.vesselPosition)
                        : ' -'
                    }`,
                  },
                ],
              },
            ],
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'VOLUME:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.volume
                        ? `${this.inspection.namePlate.volume} L`
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'FLUIDO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.equipment
                      && this.inspection.equipment.fluid
                        ? this.inspection.equipment.fluid
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'CATEGORIA:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.category
                        ? this.inspection.namePlate.category
                        : ' -'
                    }`,
                  },
                ],
              },
            ],
            // END
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, false],
                text: [
                  {
                    text: 'GRUPO DE RISCO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.riskGroup
                        ? this.inspection.namePlate.riskGroup
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, false],
                text: [
                  {
                    text: 'FUNÇÃO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.namePlate
                      && this.inspection.namePlate.vesselFunction
                        ? this.inspection.namePlate.vesselFunction
                        : ' -'
                    }`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, false],
                text: [
                  {
                    text: 'LOCAL DO VASO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.equipment
                      && this.inspection.equipment.location
                        ? this.inspection.equipment.location
                        : ' -'
                    }`,
                  },
                ],
              },
            ],
          ],
        },
      },
      // SECOND TABLE
      {
        margin: [0, 25, 0, 0],
        layout: {
          vLineColor: 'gray',
          hLineColor: 'gray',
        },
        table: {
          widths: ['40%', '12.5%', '12.5%', '35%'],
          body: [
            // HEADER
            [
              {
                style: 'tableHeader',
                text: 'DADOS DA INSPEÇÃO',
                colSpan: 4,
                border: [false, false, false, true],
              },
              {},
              {},
              {},
            ],
            // CONTENT
            // FIRST
            [
              {
                border: [false, false, false, true],
                style: 'tableContentFirst',
                text: [
                  {
                    text: 'NÚMERO TAP:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.tapNumber || ' -'}`,
                  },
                ],
              },
              {
                style: 'tableContentFirst',
                border: [false, false, false, true],
                colSpan: 2,
                text: [
                  {
                    text: 'RELATÓRIO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.reportNumber || ' -'}`,
                  },
                ],
              },
              {},
              {
                style: 'tableContentFirst',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'DATA DA INSPEÇÃO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection?.createdAt
                        ? format(new Date(this.inspection.createdAt), 'dd/MM/yyy')
                        : ' -'
                    }`,
                  },
                ],
              },
            ],
            // OTHERS
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'PRESSÃO DE OPERAÇÃO:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${formatPressureValue(
                      this.inspection && this.inspection.namePlate
                        && this.inspection.namePlate.operatingPressure,
                    )}`,
                  },
                ],
              },
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                colSpan: 2,
                text: [
                  {
                    text: 'PMTA:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${
                      this.inspection
                      && this.inspection.currentPMTA
                      && !isNaN(this.inspection.currentPMTA)
                        ? parseFloat(this.inspection.currentPMTA).toFixed(2)
                        : ' -'
                    } [bar]`,
                  },
                ],
              },
              {},
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                text: [
                  {
                    text: 'PTH:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${formatPressureValue(
                      this.inspection && this.inspection.namePlate
                        && this.inspection.namePlate.hidrostatico,
                    )}`,
                  },
                ],
              },
            ],
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, true],
                colSpan: 4,
                text: [
                  {
                    text: 'ART:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.art || ' -'}`,
                  },
                ],
              },
              {},
              {},
              {},
            ],
            // END
            [
              {
                style: 'tableContentOthers',
                border: [false, false, false, false],
                colSpan: 2,
                text: [
                  {
                    text: 'PRÓXIMA INSPEÇÃO EXTERNA:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.dateToExternalInsp || ' -'}`,
                  },
                ],
              },
              {},
              {
                style: 'tableContentOthers',
                border: [false, false, false, false],
                colSpan: 2,
                text: [
                  {
                    text: 'PRÓXIMA INSPEÇÃO INTERNA:',
                    color: '#7e97ad',
                  },
                  {
                    text: ` ${this.inspection?.dateToInternalInsp || ' -'}`,
                  },
                ],
              },
              {},
            ],
          ],
        },
      },
      // THIRD TABLE — uma tabela por válvula cadastrada (ver renderValveTables)
      this.renderValveTables(),
      // FOURTH TABLE
      this.manometer && this.manometer.brand
        ? {
          margin: [0, 25, 0, 0],
          layout: {
            vLineColor: 'gray',
            hLineColor: 'gray',
          },
          table: {
            widths: ['30%', '35%', '35%'],
            body: [
              // HEADER
              [
                {
                  style: 'tableHeader',
                  text: 'DADOS DO MANÔMETRO',
                  colSpan: 3,
                  border: [false, false, false, true],
                },
                {},
                {},
              ],
              // CONTENT
              // FIRST
              [
                {
                  border: [false, false, false, true],
                  style: 'tableContentFirst',
                  text: [
                    {
                      text: 'FABRICANTE:',
                      color: '#7e97ad',
                    },
                    {
                      text: ` ${this.manometer.brand || ' -'}`,
                    },
                  ],
                },
                {
                  style: 'tableContentFirst',
                  border: [false, false, false, true],
                  text: [
                    {
                      text: 'ESCALA EM BAR:',
                      color: '#7e97ad',
                    },
                    {
                      text: ` ${this.formatBarRange(
                        this.manometer.indRangeStart,
                        this.manometer.indRangeEnd,
                      )} [bar]`,
                    },
                  ],
                },
                {
                  style: 'tableContentFirst',
                  border: [false, false, false, true],
                  text: [
                    {
                      text: 'ESCALA EM PSI:',
                      color: '#7e97ad',
                    },
                    {
                      text: ` ${this.formatBarRange(
                        this.manometer.indRangeStart,
                        this.manometer.indRangeEnd,
                        14.5038,
                      )} [PSI]`,
                    },
                  ],
                },
              ],
              // OTHERS
              [
                {
                  style: 'tableContentOthers',
                  border: [false, false, false, true],
                  text: [
                    {
                      text: 'DIÂMETRO DA CONEXÃO:',
                      color: '#7e97ad',
                    },
                    {
                      text: ` ${this.manometer.cDiameter ? `${this.manometer.cDiameter}"` : ' -'}`,
                    },
                  ],
                },
                {
                  style: 'tableContentOthers',
                  border: [false, false, false, true],
                  text: [
                    {
                      text: 'CLASSE:',
                      color: '#7e97ad',
                    },
                    {
                      text: ' -',
                    },
                  ],
                },
                {
                  style: 'tableContentOthers',
                  border: [false, false, false, true],
                  text: [
                    {
                      text: 'LACRE:',
                      color: '#7e97ad',
                    },
                    {
                      text: ` ${this.manometer.seal || ' -'}`,
                    },
                  ],
                },
              ],
              // END
              [
                {
                  style: 'tableContentOthers',
                  border: [false, false, false, false],
                  colSpan: 3,
                  text: [
                    {
                      text: 'CALIBRADO POR:',
                      color: '#7e97ad',
                    },
                    {
                      text: ' FERNANDO GUIMARÃES DE SOUSA',
                    },
                  ],
                },
                {},
                {},
              ],
            ],
          },
        }
        : this.renderManometerAccessoryTables(),
      // "Dados do Dreno" removido a pedido do cliente
    ];
  }

  capitalize(str) {
    return str 
      ? str.charAt(0).toUpperCase() + str.slice(1) 
      : ' -';
  }

  /**
   * CONSTRUCTOR
   */
  pdfMaker() {
    return {
      pageSize: 'A4',
      // [left,top,right,botton]
      pageMargins: [
        this.cmToPoint(1.4),
        this.cmToPoint(3.3),
        this.cmToPoint(1.7),
        this.cmToPoint(3),
      ],
      defaultStyle: {
        fontSize: 12,
      },
      header: () => this.header({
        engetapLogo: assetsEngLogo,
      }),
      content: this.content(),
      styles,
    };
  }
}

export default InspectionPDF;
